// extracted by mini-css-extract-plugin
export default {"wrapImg":"DevSection_wrapImg__vP8ou"};